export default "__VITE_ASSET__nw2fxxXhIRyp1w4ag_P6OQ__"